<div class="panel panel-flat">
  <div class="content-group">
    <div class="page-header page-header-default">
      <div class="page-header-content">
        <div class="page-title">
          <h5>
            <i class="icon-people position-left"></i>
            <span class="text-semibold">Customers</span>
          </h5>
        </div>

        <div class="heading-elements">
          <div class="btn-group pull-right">
            <a (click)="getProfileFilter('')" type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">

              <i class="icon-reload-alt position-left"></i> Refresh</a>
            <a type="button" class="btn btn-icon btn-sm bg-slate-800 btn-rounded">
              <i class="icon-printer position-left"></i>Print</a>
          </div>
        </div>
      </div>
    </div>

    <div class="row" style="padding-left:30px;">
      <div class="col-md-2 form-group required">
        <span style="float:left" class="control-label">Filter by: </span>
        <select name="status" required [(ngModel)]="filter" (ngModelChange)="getProfileFilter(filter)"
          class="form-control">
          <option selected disabled>Region</option>
          <option value="&region=">All</option>
          <option value="&region=addis ababa">Addis Ababa</option>
          <option value="&region=afar">Afar</option>
          <option value="&region=oromiya">Oromiya</option>
          <option value="&region=amhara">Amhara</option>
          <option value="&region=tigray">Tigray</option>
          <option value="&region=harari">Amhara</option>
          <option value="&region=sidama">Sidama</option>
          <option value="&region=benishangul">Benishangul</option>
          <option value="&region=diredawa">Diredawa</option>
          <option value="&region=gambela">Gambela</option>
          <option value="&region=somali">Somali</option>
          <option value="&region=snnp">SNNP</option>
        </select>
      </div>

      <div class="col-md-3 form-group required">
        <span class="control-label">&nbsp; </span>
      </div>
    </div>
    <div class="panel-body">
      <table class="table datatable-column-search-inputs">
        <thead>
          <tr>
            <th>User</th>
            <th>Gender</th>
            <th>Legal ID</th>
            <th>Region</th>
            <th>City</th>
            <th>Woreda/Kebele</th>
            <th>House #</th>
            <th>Emergency Contact</th>
            <th>Created</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let profile of profiles | paginate: { id: 'profiles',itemsPerPage: itemsPerPage,currentPage: currentPage,totalItems: totalItems }">
            <td>
              <div class="media">
                <span class="media-left">
                  <img *ngIf="!profile?.user?.data?.avatar" src="assets/img/userm.png" width="40" height="40"
                    class="img-circle img-md" alt="">
                  <a href="javascript:void(0)" (click)="setProfileUrl(profile.imageUrl,profile.legalIdUrl)"
                    data-toggle="modal" data-target="#profileImModal">
                    <img *ngIf="profile?.user?.data?.avatar"
                      [src]="baseUrl+'assets/'+profile.user.data.avatar+'/render'" width="40" height="40"
                      class="img-circle img-md" alt="">
                  </a>
                </span>
                <div class="media-left">
                  <a href="" [routerLink]="['/customer',profile.id]">{{profile?.user.data.username}}
                    <div class="text-muted text-size-small">
                      {{profile?.email}}
                    </div>
                  </a>
                </div>
              </div>
            </td>
            <td>{{profile.gender}}</td>
            <td>{{profile.id_passport_number}}</td>
            <td>{{profile?.region}}</td>
            <td>
              <div class="media">
                <div class="media-left">{{profile?.city}}
                  <div class="text-muted text-size-small">
                    {{profile?.sub_city}}
                  </div>
                </div>
              </div>
            </td>
            <td>{{profile.woreda_kebele}}</td>
            <td>{{profile.house_no}}</td>
            <td>
              <div class="media">
                <div class="media-left">{{profile?.emergency_contact}}
                  <div class="text-muted text-size-small">
                    {{profile?.emergency_phone}}
                  </div>
                </div>
              </div>
            </td>
            <td>{{profile.created_at|date:short}}</td>
            <td>
              <span class="label label-block label-default"
                *ngIf="profile.status === 'Pending' || profile.status === 'pending'">{{profile.status}}</span>
              <span class="label label-block label-primary"
                *ngIf="profile.status === 'Verified' || profile.status === 'verified'">{{profile.status}}</span>

            </td>
            <td class="text-center">
              <ul class="icons-list">
                <li class="dropdown">
                  <a href="" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="icon-menu9"></i>
                  </a>

                  <ul class="dropdown-menu dropdown-menu-right">
                    <li>
                      <a [routerLink]="['/customeradd']" [queryParams]="{'id':profile.id,'user':profile?.user.data.id}">
                        <i class="icon-file-pdf"></i>Update</a>
                    </li>
                    <li>
                      <a href="">
                        <i class="icon-file-excel"></i>Delete</a>
                    </li>
                    <li class="dropdown-submenu dropdown-submenu-left">
                      <a href="javascript:void(0);">Change Status</a>
                      <ul class="dropdown-menu">
                        <li>
                          <a (click)="changeStatus(profile.id,'pending')">
                            <i class="icon-shuffle"></i> Pending</a>
                        </li>
                        <li>
                          <a (click)="changeStatus(profile.id,'verified')">
                            <i class="icon-shuffle"></i> Verified</a>
                        </li>
                      </ul>
                    </li>
                    <li class="divider"></li>
                    <li>
                      <a href="javascript:void(0)" (click)="setUser(profile)" data-toggle="modal"
                        data-target="#modal_form_vertical">
                        <i class="icon-cash"></i> Enroll To Ekub</a>
                    </li>
                  </ul>
                </li>
              </ul>
            </td>
          </tr>
          <tr *ngIf="profiles?.length <=0">
            <td colspan="10" class="text-center"> <i class="icon-info22">&nbsp;</i>No Customers yet!</td>
          </tr>
        </tbody>
      </table>

      <div class="row">
        <div class="text-center">
          <pagination-controls id="profiles" (pageChange)="pageChanged(currentPage = $event)">
          </pagination-controls>
          <br>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Iconified modal -->
<div id="modal_iconified" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title"><i class="icon-menu7"></i> &nbsp;Modal with icons</h5>
      </div>

      <div class="modal-body">
        <div class="alert alert-info alert-styled-left text-blue-800 content-group">
          <span class="text-semibold">Here we go!</span> Example of an alert inside modal.
          <button type="button" class="close" data-dismiss="alert">×</button>
        </div>

        <h6 class="text-semibold"><i class="icon-law position-left"></i> Sample heading with icon</h6>
        <p>Cras mattis consectetur purus sit amet fermentum. Cras justo odio, dapibus ac facilisis in, egestas eget
          quam. Morbi leo risus, porta ac consectetur ac, vestibulum at eros.</p>

        <hr>

        <p><i class="icon-mention position-left"></i> Aenean lacinia bibendum nulla sed consectetur. Praesent commodo
          cursus magna, vel scelerisque nisl consectetur et. Donec sed odio dui. Donec ullamcorper nulla non metus
          auctor fringilla.</p>
      </div>

      <div class="modal-footer">
        <button class="btn btn-link" data-dismiss="modal"><i class="icon-cross"></i> Close</button>
        <button class="btn btn-primary"><i class="icon-check"></i> Save</button>
      </div>
    </div>
  </div>
</div>
<!-- /iconified modal -->

<!-- Vertical form modal -->
<div id="modal_form_vertical" class="modal fade" tabindex="-1">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Enroll Customer to Ekub</h5>
      </div>

      <form name="userEkubForm" [formGroup]="userEkubForm" novalidate>
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div class="col-sm-6">
                <label>User</label>
                <input type="text" placeholder="User" readonly class="form-control" [(ngModel)]="selectedUser.username"
                  formControlName="user">
              </div>

              <div class="col-sm-6">
                <label>Ekub</label>
                <ng-select [items]="ekubs" placeholder="select ekub" formControlName="ekub" bindValue="id"
                  bindLabel="ekub_id" required>
                </ng-select>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-6 required">
                <span class="control-label">Status: </span>
                <select name="status" required formControlName="status" class="form-control"
                  data-placeholder="Select ekub status">
                  <option selected disabled>Status:</option>
                  <option value="pending">Pending</option>
                  <option value="active">Active</option>
                  <option value="completed">Completed</option>
                </select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Ekub status is required.
                  </p>
                </div>
              </div>


              <div class="col-sm-6 required">
                <span class="control-label">Branch: </span>
                <ng-select [items]="branches" placeholder="" formControlName="branch" bindValue="id" bindLabel="text"
                  required>
                </ng-select>
                <div class="help-block" *ngIf="status.invalid && (status.dirty || status.touched)">
                  <p class="text-danger">
                    <i class="icon-cancel-circle2 position-left"></i>Ekub status is required.
                  </p>
                </div>
              </div>







            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-sm-12">
                <label>&nbsp;</label>
                <label>Remark:</label>
                <textarea rows="5" cols="5" class="form-control" name="remark" formControlName="remark"
                  placeholder="Additional information . . ."></textarea>
              </div>
            </div>
          </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
          <button (click)="enrollUser()" data-dismiss="modal" class="btn bg-slate-800">Enroll Customer</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!-- /vertical form modal -->

<!-- Confirm modal -->
<div id="confirmModal" class="modal fade" tabindex="-1">
  <div class="modal-dialog modal-xs">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h5 class="modal-title">Confirm Multiple Enrollement</h5>
      </div>
      <div class="modal-body">
        <p>This user is already enrolled into this ekub</p>
        <hr>
        <p>If you are sure and you want to enroll this user multiple times into this ekub, Click <span
            class="text-danger">Confirm</span> other wise click <span class="text-success">cancel</span></p>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-link" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addEnrollement()" class="btn btn-primary" data-dismiss="modal">Confirm</button>
      </div>
    </div>
  </div>
</div>
<!-- /Confirm modal -->

<a href="" [hidden]="true" id="openModal" data-toggle="modal" data-target="#confirmModal" class="tx-info">
  <i class="fa fa-plus-circle mg-r-5"></i><u>Confirm MultiEnrollement</u>
</a>